<template>
  <div v-bind:id="id" class="modal" v-bind:class="{active: showModal}" v-show="showModal">
    <a href="javascript:void(0)" class="modal-closer" aria-label="ダイアログを閉じる" v-on:click="closeModal"></a>
    <div class="contents">
      <div class="modal-header">
        本日のピックアップ！<br />
        リーダーたちへ
      </div>
      <div class="modal-body">
        <h5>～実際に投げかけられた～(ヒント集より)<br />{{ categoryLabel }}</h5>
        <p style="white-space: pre-line">{{ body }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import DailyHint from '../components/daily-hint'

  export default {
    name: 'DailyHintSp',
    extends: DailyHint,
    data () {
      return {
        isDialog: true
      }
    }
  }
</script>
